import { RulebookPage } from "@/components/RulebookPage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { currentRules } from "@/data/rules";
import { DescriptionBlocks } from "./DescriptionBlocks";
import type { Patron } from "@/data/types";

function PatronCard({ patron }: { patron: Patron }) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">{patron.name}</CardTitle>
      </CardHeader>
      <CardContent className="text-sm text-muted-foreground">
        {patron.full_description ? (
          <DescriptionBlocks blocks={patron.full_description} />
        ) : (
          <p className="mb-2">{patron.description}</p>
        )}
        {patron.challenges.length > 0 && (
          <div className="mt-3">
            <p className="font-medium text-foreground mb-1">
              <Badge variant="outline" className="mr-2">
                Daily Challenges
              </Badge>
            </p>
            <ul className="list-disc list-inside space-y-1">
              {patron.challenges.map((challenge, i) => (
                <li key={i}>{challenge}</li>
              ))}
            </ul>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export function Patrons() {
  const thirteen = currentRules.patrons.filter((p) => !p.exiled);
  const previous = currentRules.patrons.filter((p) => p.exiled);

  return (
    <RulebookPage title="Patrons">
      <p className="text-sm text-muted-foreground mb-3">
        There are countless entities that dwell beyond the borders of the
        physical world — this list represents only a small selection of Patrons
        that are commonly known among Warlocks!
      </p>
      <p className="text-sm text-muted-foreground mb-6">
        For each Dark Offering you have made, you must decide which Patron you
        have given it to. These beings will reward your sacrifice with powerful
        Otherworldly Gifts. Each Patron is known by a simple title. While a
        Patron&apos;s alignment and personality are well-documented, their
        appearance can be as varied as their moods.
      </p>

      <div className="grid gap-3">
        {thirteen.map((patron) => (
          <PatronCard key={patron.id} patron={patron} />
        ))}
      </div>

      {previous.length > 0 && (
        <>
          <h2 className="text-xl font-semibold mt-6 mb-2">Previous Patrons</h2>
          <p className="text-sm text-muted-foreground mb-3">
            These Patrons were once members of the Thirteen. They can still
            award MP for completing their Challenges, and can be summoned, but
            no longer count towards completing the Challenge of 13 or achieving
            Ultimate Warlock.
          </p>
          <div className="grid gap-3">
            {previous.map((patron) => (
              <PatronCard key={patron.id} patron={patron} />
            ))}
          </div>
        </>
      )}
    </RulebookPage>
  );
}
